const SELECTOR_INPUT = '#phx_billing_game_world';
const SELECTOR_DATA_CONTAINER = '#game-world-selection-additonal-data';

const {jQuery} = window;

export default class GameWorldSelection {

    input = null;
    dataContainer = null;
    dataPanels = {};
    currentSelection = null;
    select2Instance = null;

    constructor() {
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    init() {
        this.input = document.querySelector(SELECTOR_INPUT);
        this.dataContainer = document.querySelector(SELECTOR_DATA_CONTAINER);

        if (!this.input || !this.dataContainer) {
            return;
        }

        [...this.dataContainer.querySelectorAll('[data-world]')].forEach(el => {
            const world = el.dataset.world;
            this.dataPanels[world] = el;
        });

        this.initSelect2();
        this.registerEvents();
    }

    registerEvents() {
        this.select2Instance.on('change', this.onChange.bind(this));
    }

    initSelect2() {
        this.select2Instance = jQuery(this.input).select2();
    }

    onChange() {
        this.setCurrentSelection(this.select2Instance.select2('data'));

        this.closeAllDataPanels();
        this.openDataPanel(this.dataPanels[this.currentSelection]);
    }

    setCurrentSelection(data) {
        this.currentSelection = data[0].id;
    }

    openDataPanel(el) {
        el.style.display = '';
        el.setAttribute('aria-hidden', false);
    }

    closeDataPanel(el) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', true);
    }

    closeAllDataPanels() {
        for (const [key, el] of Object.entries(this.dataPanels)) {
            this.closeDataPanel(el);
        }
    }

}